export const iconFontAwesomeMapsTrophy = (
	<i className="fa-solid fa-trophy"></i>
);
